import { render, staticRenderFns } from "./MantenedorCoordinadorPantalla.vue?vue&type=template&id=71f72820&"
import script from "./MantenedorCoordinadorPantalla.vue?vue&type=script&lang=ts&"
export * from "./MantenedorCoordinadorPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('71f72820', component.options)
    } else {
      api.reload('71f72820', component.options)
    }
    module.hot.accept("./MantenedorCoordinadorPantalla.vue?vue&type=template&id=71f72820&", function () {
      api.rerender('71f72820', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/MantenedorCoordinador/MantenedorCoordinadorPantalla.vue"
export default component.exports